"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/tabs/index.ts
var tabs_exports = {};
__export(tabs_exports, {
  default: () => Tabs_default
});
module.exports = __toCommonJS(tabs_exports);
var import_index3 = require("./index.css");

// src/tabs/Tabs.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react4 = require("react");

// src/tabs/_Tab.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react3 = require("react");

// src/closeButton/index.ts
var import_index = require("./index.css");

// src/closeButton/CloseButton.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames2.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes3,
    children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/tooltip/index.ts
var import_index2 = require("./index.css");

// src/tooltip/_Tooltip.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react = require("react");

// src/tooltip/tooltip.module.scss
var tooltip_module_default = {
  "heading-xxl": "tooltip-module__heading-xxl___Wxave",
  "wrapper": "tooltip-module__wrapper___lLLSP",
  "heading-xl": "tooltip-module__heading-xl___9SIFv",
  "heading-lg": "tooltip-module__heading-lg___pBoyG",
  "heading-md": "tooltip-module__heading-md___zYoPi",
  "heading-sm": "tooltip-module__heading-sm___h6LQC",
  "heading-xs": "tooltip-module__heading-xs___zF1vt",
  "body-one": "tooltip-module__body-one___kliHg",
  "body-two": "tooltip-module__body-two___zmg0f",
  "body-three": "tooltip-module__body-three___Huwkw",
  "body-four": "tooltip-module__body-four___YJRVJ",
  "overline-one": "tooltip-module__overline-one___ykjq0",
  "overline-two": "tooltip-module__overline-two___QcjzG",
  "overline-three": "tooltip-module__overline-three___fba7M",
  "strong": "tooltip-module__strong___531QW",
  "em": "tooltip-module__em___9DUCL",
  "figcaption": "tooltip-module__figcaption___4dBW5",
  "no-margin": "tooltip-module__no-margin___0cPC6",
  "tooltipOverlay": "tooltip-module__tooltipOverlay___I-rkD",
  "tooltip": "tooltip-module__tooltip___3zeep",
  "tooltipText": "tooltip-module__tooltipText___-H-vF",
  "noTail": "tooltip-module__noTail___zeZr2",
  "tooltip-onTop": "tooltip-module__tooltip-onTop___WQLw1",
  "tooltip-onRight": "tooltip-module__tooltip-onRight___CBYB-",
  "tooltip-onBottom": "tooltip-module__tooltip-onBottom___zqQPq",
  "tooltip-onLeft": "tooltip-module__tooltip-onLeft___dXcgj",
  "tooltip-l": "tooltip-module__tooltip-l___YiC-j",
  "tooltip-m": "tooltip-module__tooltip-m___Yi8VT",
  "tooltip-s": "tooltip-module__tooltip-s___18FfP",
  "tooltip-xs": "tooltip-module__tooltip-xs___v4Wsu"
};

// src/tooltip/_Tooltip.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var TooltipOverlay = ({
  children,
  className
}) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_classnames3.default)(tooltip_module_default.tooltipOverlay, className), children });
var Tooltip = (0, import_react.forwardRef)(
  ({
    text,
    tooltipId,
    iconLeft,
    iconRight,
    direction = "onTop",
    className,
    size = "m",
    style = {},
    hideTail = false,
    ...HTMLAttributes3
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
      "div",
      {
        ref,
        id: tooltipId,
        "aria-live": "polite",
        className: (0, import_classnames3.default)(
          tooltip_module_default.tooltip,
          tooltip_module_default[`tooltip-${direction}`],
          tooltip_module_default[`tooltip-${size}`],
          hideTail && tooltip_module_default.noTail,
          className
        ),
        style,
        role: "tooltip",
        ...HTMLAttributes3,
        children: [
          iconLeft && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { className: tooltip_module_default.tooltipText, children: text }),
          iconRight && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconRight })
        ]
      }
    );
  }
);
var Tooltip_default = Tooltip;

// src/tooltip/WithTooltip.tsx
var import_react2 = require("react");
var import_react_dom = require("react-dom");

// src/common/helpers/index.ts
var calculatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  tailOffset: tailOffset2,
  tailLength
}) => {
  const styles = {
    position: "absolute",
    inset: "0px auto auto 0px"
  };
  let effectiveDirection = direction;
  if (nodePosition && positionedElementRef.current && direction !== "none") {
    const rect = nodePosition.getBoundingClientRect();
    const tooltipRect = positionedElementRef.current.getBoundingClientRect();
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const textDirection = document.documentElement.dir || "ltr";
    const isLtr = textDirection === "ltr";
    let top = 0;
    let left = 0;
    const calculatePosition = (dir) => {
      switch (dir) {
        case "onRight":
          top = rect.top + scrollY + rect.height / 2 - tooltipRect.height / 2;
          left = (isLtr ? rect.right : rect.left - tooltipRect.width) + scrollX + tailOffset2 + tailLength;
          break;
        case "onBottom":
          top = rect.bottom + scrollY + tailOffset2 + tailLength;
          left = rect.left + scrollX + rect.width / 2 - tooltipRect.width / 2;
          break;
        case "onLeft":
          top = rect.top + scrollY + rect.height / 2 - tooltipRect.height / 2;
          left = (isLtr ? rect.left - tooltipRect.width : rect.right) + scrollX - tailOffset2 - tailLength;
          break;
        case "onTop":
        default:
          top = rect.top + scrollY - tooltipRect.height - tailOffset2 - tailLength;
          left = rect.left + scrollX + rect.width / 2 - tooltipRect.width / 2;
          break;
      }
      return { top, left };
    };
    const fitsInViewport = (pos) => {
      return pos.top >= scrollY && pos.top + tooltipRect.height <= scrollY + viewportHeight && pos.left >= scrollX && pos.left + tooltipRect.width <= scrollX + viewportWidth;
    };
    let proposedPosition = calculatePosition(direction);
    if (!fitsInViewport(proposedPosition)) {
      const flipDirection = {
        onRight: "onLeft",
        onLeft: "onRight",
        onTop: "onBottom",
        onBottom: "onTop"
      }[direction];
      const flippedPosition = calculatePosition(
        flipDirection
      );
      if (fitsInViewport(flippedPosition)) {
        proposedPosition = flippedPosition;
        effectiveDirection = flipDirection;
      }
    }
    proposedPosition.top = Math.min(
      Math.max(proposedPosition.top, scrollY + tailOffset2),
      scrollY + viewportHeight - tooltipRect.height - tailOffset2
    );
    proposedPosition.left = Math.min(
      Math.max(proposedPosition.left, scrollX + tailOffset2),
      scrollX + viewportWidth - tooltipRect.width - tailOffset2
    );
    styles.transform = `translate3d(${proposedPosition.left}px, ${proposedPosition.top}px, 0px)`;
  }
  return { styles, effectiveDirection };
};
var updatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  setPositionedElementStyles,
  setPositionedElementDirection,
  tailOffset: tailOffset2,
  tailLength
}) => {
  const { styles, effectiveDirection } = calculatePositionedElementStyles({
    nodePosition,
    positionedElementRef,
    direction,
    tailOffset: tailOffset2,
    tailLength
  });
  if (effectiveDirection && effectiveDirection !== "none" && effectiveDirection !== direction) {
    setPositionedElementDirection(effectiveDirection);
  } else {
    setPositionedElementStyles(styles);
  }
};

// src/tooltip/WithTooltip.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var tailOffset = 4;
var tailLengths = {
  l: 12,
  m: 9,
  s: 6,
  xs: 6
};
var WithTooltip = (0, import_react2.forwardRef)(
  ({
    children,
    tooltipOverlayClassName,
    tooltipProps,
    hideDelayMs,
    hideOnFirstLeave
  }, ref) => {
    const [nodePosition, setNodePosition] = (0, import_react2.useState)(null);
    const [showTooltip, setShowTooltip] = (0, import_react2.useState)(false);
    const [actualDirection, setActualDirection] = (0, import_react2.useState)(tooltipProps.direction || "onTop");
    const [tooltipStyles, setTooltipStyles] = (0, import_react2.useState)({});
    const tooltipRef = (0, import_react2.useRef)(null);
    const hideTimeoutRef = (0, import_react2.useRef)(null);
    const prevDirectionRef = (0, import_react2.useRef)(
      tooltipProps.direction
    );
    const suppressNextFocusRef = (0, import_react2.useRef)(false);
    const clearHideTimeout = () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
    const handleShowTooltip = (show, event, isTooltip = false) => {
      if (suppressNextFocusRef.current && event.type === "focus") {
        suppressNextFocusRef.current = false;
        return;
      }
      setShowTooltip(show);
      clearHideTimeout();
      if (!isTooltip) {
        setNodePosition(show ? event.target : null);
      }
    };
    const handleHideTooltip = () => {
      hideTimeoutRef.current = window.setTimeout(() => {
        setShowTooltip(false);
        setNodePosition(null);
      }, hideDelayMs || 100);
    };
    (0, import_react2.useImperativeHandle)(ref, () => ({
      hideTooltip: () => {
        clearHideTimeout();
        setShowTooltip(false);
        setNodePosition(null);
        suppressNextFocusRef.current = true;
      }
    }));
    const tailLength = tailLengths[tooltipProps.size || "m"];
    const updateTooltipStyles = (0, import_react2.useCallback)(
      () => updatePositionedElementStyles({
        nodePosition,
        positionedElementRef: tooltipRef,
        direction: actualDirection,
        setPositionedElementStyles: setTooltipStyles,
        setPositionedElementDirection: setActualDirection,
        tailOffset,
        tailLength
      }),
      [nodePosition, tailLength, actualDirection]
    );
    (0, import_react2.useEffect)(() => {
      const updateTooltipPositionIfShown = () => {
        if (showTooltip) {
          updateTooltipStyles();
        }
      };
      updateTooltipPositionIfShown();
      window.addEventListener("resize", updateTooltipPositionIfShown);
      return () => {
        window.removeEventListener("resize", updateTooltipPositionIfShown);
      };
    }, [showTooltip, nodePosition, actualDirection, updateTooltipStyles]);
    (0, import_react2.useEffect)(() => {
      if (tooltipProps.direction && tooltipProps.direction !== prevDirectionRef.current) {
        prevDirectionRef.current = tooltipProps.direction;
        setActualDirection(tooltipProps.direction);
        updateTooltipStyles();
      }
    }, [tooltipProps.direction]);
    (0, import_react2.useEffect)(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          handleHideTooltip();
        }
      };
      if (showTooltip) {
        document.addEventListener("keydown", handleKeyDown);
      }
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [showTooltip]);
    const tooltipStyleProps = {
      visibility: showTooltip ? "visible" : "hidden",
      ...tooltipStyles,
      ...tooltipProps.style
    };
    const componentToWrap = (0, import_react2.isValidElement)(children) && (0, import_react2.cloneElement)(children, {
      "aria-describedby": tooltipProps.tooltipId,
      onFocus: (event) => {
        var _a, _b;
        handleShowTooltip(true, event);
        (_b = (_a = children.props).onFocus) == null ? void 0 : _b.call(_a, event);
      },
      onBlur: (event) => {
        var _a, _b;
        handleHideTooltip();
        (_b = (_a = children.props).onBlur) == null ? void 0 : _b.call(_a, event);
      },
      onMouseEnter: (event) => {
        var _a, _b;
        handleShowTooltip(true, event);
        (_b = (_a = children.props).onMouseEnter) == null ? void 0 : _b.call(_a, event);
      },
      onMouseLeave: (event) => {
        var _a, _b;
        handleHideTooltip();
        (_b = (_a = children.props).onMouseLeave) == null ? void 0 : _b.call(_a, event);
      }
    });
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(TooltipOverlay, { className: tooltipOverlayClassName, children: [
      componentToWrap,
      showTooltip && (0, import_react_dom.createPortal)(
        /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          Tooltip_default,
          {
            ...tooltipProps,
            direction: actualDirection,
            ref: tooltipRef,
            style: tooltipStyleProps,
            onMouseEnter: (event) => !hideOnFirstLeave && handleShowTooltip(true, event, true),
            onMouseLeave: handleHideTooltip
          }
        ),
        document.body
      )
    ] });
  }
);
var WithTooltip_default = WithTooltip;

// src/tabs/tabs.module.scss
var tabs_module_default = {
  "heading-xxl": "tabs-module__heading-xxl___2NIbc",
  "wrapper": "tabs-module__wrapper___bRnkm",
  "heading-xl": "tabs-module__heading-xl___B23y4",
  "heading-lg": "tabs-module__heading-lg___2WpfZ",
  "heading-md": "tabs-module__heading-md___LRmO3",
  "heading-sm": "tabs-module__heading-sm___iXfWn",
  "heading-xs": "tabs-module__heading-xs___TTil1",
  "body-one": "tabs-module__body-one___mE3BS",
  "body-two": "tabs-module__body-two___5suY-",
  "body-three": "tabs-module__body-three___LMfKI",
  "body-four": "tabs-module__body-four___vepqu",
  "overline-one": "tabs-module__overline-one___3xXOn",
  "overline-two": "tabs-module__overline-two___ZISxj",
  "overline-three": "tabs-module__overline-three___BvGqt",
  "strong": "tabs-module__strong___-86cT",
  "em": "tabs-module__em___mBh7b",
  "figcaption": "tabs-module__figcaption___WcNog",
  "no-margin": "tabs-module__no-margin___51BIq",
  "tabs": "tabs-module__tabs___4BiXZ",
  "tabs-primary": "tabs-module__tabs-primary___IIP8W",
  "tabs-light": "tabs-module__tabs-light___fw3pw",
  "selectedTab": "tabs-module__selectedTab___VTozz",
  "tabs-dark": "tabs-module__tabs-dark___T-1M-",
  "tabs-secondary": "tabs-module__tabs-secondary___4n5RT",
  "tabs-_tabGroup": "tabs-module__tabs-_tabGroup___hhqjJ",
  "tabs-l": "tabs-module__tabs-l___eV7tL",
  "iconOnlyTab": "tabs-module__iconOnlyTab___HVnWX",
  "tabs-m": "tabs-module__tabs-m___pR394",
  "tabs-s": "tabs-module__tabs-s___zxPLR",
  "tabs-xs": "tabs-module__tabs-xs___fXdAy"
};

// src/tabs/_Tab.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var checkTabForErrors = (isIconOnly, icon, text) => {
  if (isIconOnly && !icon) {
    throw new Error("IconOnly tabs must have an icon");
  }
  if (!isIconOnly && !text) {
    throw new Error("Tabs that are not icon only must have text");
  }
};
var renderTabButtonContent = (isIconOnly, icon, text, iconLeft, iconRight, tabTextRef) => {
  if (isIconOnly && icon) {
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...icon });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(import_jsx_runtime5.Fragment, { children: [
    iconLeft && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
    text && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { ref: tabTextRef, children: text }),
    iconRight && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...iconRight })
  ] });
};
var _Tab = ({
  isSelected,
  onClick,
  value,
  text,
  iconLeft,
  iconRight,
  icon,
  tooltip,
  size,
  tabPanelId,
  tabButtonId,
  disabled = false,
  isIconOnly = false,
  isClosable = false,
  onClose = () => {
  }
}) => {
  const [overflowTooltip, setOverflowTooltip] = (0, import_react3.useState)();
  const tabTextRef = (0, import_react3.useRef)(null);
  const handleClick = (0, import_react3.useCallback)(() => onClick(value), [onClick, value]);
  const handleClose = (0, import_react3.useCallback)(() => onClose(value), [onClose, value]);
  checkTabForErrors(isIconOnly, icon, text);
  const buttonContent = renderTabButtonContent(
    isIconOnly,
    icon,
    text,
    iconLeft,
    iconRight,
    tabTextRef
  );
  const buttonElement = /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
    "button",
    {
      type: "button",
      role: "tab",
      "aria-selected": isSelected,
      "aria-controls": tabPanelId,
      id: tabButtonId,
      className: (0, import_classnames4.default)(
        isSelected && tabs_module_default.selectedTab,
        isIconOnly && tabs_module_default.iconOnlyTab
      ),
      onClick: handleClick,
      disabled,
      children: [
        buttonContent,
        isClosable && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
          CloseButton_default,
          {
            onClick: handleClose,
            size,
            "aria-label": `Close ${text}`
          }
        )
      ]
    }
  );
  const preferredTooltip = tooltip || overflowTooltip;
  (0, import_react3.useEffect)(() => {
    if (tabTextRef.current) {
      const textElement = tabTextRef.current;
      if (textElement.scrollWidth > textElement.clientWidth && !tooltip && text) {
        setOverflowTooltip({
          tooltipId: `${tabButtonId}-overflow-tooltip`,
          text,
          direction: "onBottom"
        });
      } else {
        setOverflowTooltip(void 0);
      }
    }
  }, [text, tooltip, tabButtonId]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("li", { role: "presentation", children: preferredTooltip ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(WithTooltip_default, { tooltipProps: preferredTooltip, children: buttonElement }) : buttonElement });
};
var Tab_default = _Tab;

// src/tabs/_TabPanel.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var _TabPanel = ({
  content,
  isActive,
  id,
  labelledBy
}) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { role: "tabpanel", id, "aria-labelledby": labelledBy, hidden: !isActive, children: content });
var TabPanel_default = _TabPanel;

// src/tabs/Tabs.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var import_react5 = require("react");
var Tabs = ({
  tabs,
  name,
  onChange,
  onTabClose = () => {
  },
  defaultSelectedTabValue,
  tabsContainerId,
  tabsContainerClassName,
  tabPanelsContainerId,
  tabPanelsContainerClassName,
  hidePanels,
  type = "primary",
  mode = "light",
  size = "m"
}) => {
  const [selectedTabValue, setSelectedValue] = (0, import_react4.useState)(
    defaultSelectedTabValue
  );
  const handleChange = (0, import_react4.useCallback)(
    (value) => {
      setSelectedValue(value);
      if (onChange) {
        onChange(value);
      }
    },
    [setSelectedValue, onChange]
  );
  const handleTabClose = (0, import_react4.useCallback)(
    (value) => {
      onTabClose(value, name);
    },
    [name, onTabClose]
  );
  (0, import_react4.useEffect)(() => {
    setSelectedValue(defaultSelectedTabValue);
  }, [defaultSelectedTabValue]);
  (0, import_react4.useEffect)(() => {
    if (!tabs.find((tab) => tab.value === selectedTabValue)) {
      setSelectedValue(tabs[0].value);
    }
  }, [tabs, selectedTabValue]);
  const nameStripped = name.replace(" ", "-");
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(import_jsx_runtime7.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "div",
      {
        className: (0, import_classnames5.default)(
          tabs_module_default.tabs,
          tabs_module_default[`tabs-${size}`],
          tabs_module_default[`tabs-${type}`],
          tabs_module_default[`tabs-${mode}`],
          tabsContainerClassName
        ),
        id: tabsContainerId,
        children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("ul", { role: "tablist", children: tabs.map((tab) => /* @__PURE__ */ (0, import_react5.createElement)(
          Tab_default,
          {
            ...tab,
            key: tab.value,
            isSelected: tab.value === selectedTabValue,
            onClick: handleChange,
            size,
            onClose: handleTabClose,
            tabPanelId: `${nameStripped}-panel-${tab.value.replace(/\s+/g, "-")}`,
            tabButtonId: `${nameStripped}-tab-${tab.value.replace(/\s+/g, "-")}`
          }
        )) })
      }
    ),
    !hidePanels && /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "div",
      {
        className: (0, import_classnames5.default)(tabPanelsContainerClassName),
        id: tabPanelsContainerId,
        children: tabs.map((tab) => /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          TabPanel_default,
          {
            content: tab.tabContent,
            isActive: tab.value === selectedTabValue,
            id: `${nameStripped}-panel-${tab.value.replace(/\s+/g, "-")}`,
            labelledBy: `${nameStripped}-tab-${tab.value.replace(/\s+/g, "-")}`
          },
          tab.value
        ))
      }
    )
  ] });
};
var Tabs_default = Tabs;
//# sourceMappingURL=index.js.map